import { Checkbox } from "primereact/checkbox";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { setChangeHistoricalDataSource } from "src/redux/slices/sharedSlice";
interface ShowHistoricalDataProps {
  showHistoricalData: boolean;
  handleFormFieldChange: (e: any) => void;
}

const ShowHistoricalData: React.FC<ShowHistoricalDataProps> = ({
  showHistoricalData,
  handleFormFieldChange,
}) => {
  const { t } = useTranslation(["common"]);
  const [index, setIndex] = useState(10); // State to hold the index
  const dispatch = useDispatch();
  const { showHistoricalDataChangeSource } = useSelector(
    (state: any) => state.shared
  );

  const handleFieldChange = (e: any) => {
    setIndex((prevIndex) => prevIndex + 1); // Increment index on each click to trigger useEffect in parent component
    handleFormFieldChange(e);
    const preIndex = parseInt(index.toString()) - 1;
    if (showHistoricalDataChangeSource === "" || showHistoricalDataChangeSource === preIndex.toString())
      dispatch(setChangeHistoricalDataSource(index.toString()));
    else
      dispatch(setChangeHistoricalDataSource(""));
  };

  return (
    <div className="d-flex align-items-center gap-1">
      <Checkbox
        checked={showHistoricalData}
        onChange={handleFieldChange}
        name="showHistoricalData"
      ></Checkbox>
      <label className="m-0">{t("showHistoricalData")}</label>
    </div>
  );
};

export default ShowHistoricalData;
